module.exports = __webpack_public_path__ + "img/potential-events_womens-world-cup.cc3b4b87.jpg";